<template lang="pug">
v-container
  //- Popup Create Inventory
  v-dialog(v-model="show_create", max-width="600")
    Inventory
  v-dialog(v-model="show_generate", max-width="600")
    GenerateInventory
  v-dialog(v-model="show_download", max-width="600")
    DownloadInventories
  v-dialog(v-model="show_qrcode", max-width="300")
    img(:src="qrcode")
  //- Header
  v-row
    v-col(cols="12", xs="12")
      h2.secondary--text Inventarios
    v-col(v-if="user.role.slug == 'admin'", cols="12", xs="12")
      v-btn(outlined, color="secondary", @click="show_create = true") Añadir Inventario
      v-btn.mt-1.ml-sm-1.mt-sm-0(color="secondary", @click="show_generate = true") Generar Inventario
      v-btn.mt-1.ml-sm-1.mt-sm-0(outlined, color="secondary", @click="show_download = true") Descargar Inventarios
  v-divider
  //- List Inventory
  Table(
    :onlyDate="true",
    :loading="loading",
    :headers="headers",
    :enableGenQR="true",
    :searchServer="true",
    @edit="editInventory",
    @delete="eraseInventory",
    @search="searchInventory",
    :items="inventory.results",
    @getPage="getInventoryPage",
    @generateQR="generateQRInventory",
    :pageCount="inventory.links.last_page",
    :itemsPerPage="inventory.links.per_page",
    :enableActions="user.role.slug == 'admin'",
  )
</template>

<script>
import utils from "@/resources/utils";
import Table from "@/components/Table.vue";
import { mapState, mapGetters } from "vuex";
import inventoryAPI from "@/api/inventories";
import Inventory from "@/components/inventories/Inventories.vue";
import GenerateInventory from "@/components/inventories/GenerateInventory.vue";
import DownloadInventories from "@/components/inventories/DownloadInventories.vue";

export default {
  name: "inventories",
  components: {
    Table,
    Inventory,
    GenerateInventory,
    DownloadInventories
  },
  async created() {
    if (!this.auth_token) {
      this.$router.push("/auth/login");
    }
    this.getInventoryPage(1);
    await this.$store.dispatch(
      "stock/getStockWithoutPagination",
      this.auth_token
    );
  },
  computed: {
    ...mapState({
      inventory: state => state.inventories.inventories,
      auth_token: state => state.auth.auth_token,
      user: state => state.auth.user
    }),
    ...mapGetters({
      choices: "selectChoices"
    })
  },
  data() {
    return {
      qrcode: null,
      loading: false,
      show_create: false,
      show_qrcode: false,
      show_generate: false,
      show_download: false,
      headers: [
        { text: "#", value: "id" },
        { text: "Fecha Venta", value: "sale_date" },
        { text: "Fecha Compra", value: "purchase_date" },
        { text: "Código", value: "code" },
        { text: "Tipo Inventario", value: "inventory_type" },
        { text: "Stock", value: "stock.brand" },
        { text: "Veterinario", value: "vet.email" },
        { text: "¿Tiene veterinario asignado?", value: "assign_vet" },
        { text: "¿Tiene mascota asignada?", value: "assign" },
        { text: "Actiones", value: "actions" }
      ],
      messages_error_or_empty: "No tienes inventarios registrados"
    };
  },
  methods: {
    async getInventoryPage(page, code) {
      this.loading = true;
      await this.$store.dispatch("inventories/getInventories", {
        page: page,
        email: null,
        assign: null,
        pagination: true,
        code: code ?? null,
        token: this.auth_token,
      });
      this.loading = false;
    },
    editInventory(inventory) {
      this.$router.push(`/inventories/${inventory.id}`);
    },
    async eraseInventory(inventory) {
      this.$swal({
        title: `¿Estas seguro de borrar el inventario para (${inventory.code})?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si",
        cancelButtonText: "No"
      }).then(async result => {
        if (result.value) {
          const response = await inventoryAPI.deleteInventory(
            inventory.id,
            this.auth_token
          );

          if (response.status) {
            this.$swal({
              title: `Inventario Borrado`,
              icon: "success"
            });
            await this.$store.dispatch("inventories/getInventories", {
              token: this.auth_token,
              page: 1
            });
          } else {
            this.$swal({
              title: response.data,
              icon: "error"
            });
          }
        }
      });
    },
    generateQRInventory(inventory) {
      if (inventory.code) {
        utils.generateQRInventory(inventory.code).then(url => {
          this.qrcode = url;
          this.show_qrcode = true;
        });
      }
    },
    async searchInventory(code) {
      await this.getInventoryPage(1, code);
    }
  }
};
</script>
